import(/* webpackMode: "eager" */ "/app/.yarn/__virtual__/next-virtual-e29b8b924f/0/cache/next-npm-14.2.25-cd023f1b24-fa0cd12ba7.zip/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/(simple-layout)/components/SimpleLayoutPageBackButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InquiryForm"] */ "/app/webapp/app/pwa/(simple-layout)/inquiry/components/InquiryForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/webapp/app/pwa/components/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/components/layout/NavBackButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/default_team_logo.png");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/user/default.svg");
